export default __webpack_public_path__ + "static/media/ZXC.210d707a.jpg";